import Search from "antd/lib/transfer/search";
import axiosInstance from "../../app/apiClient";
import { BasicUser } from "../model/account.model";


const getUserData = (status?: any, value?: any, role?: any) => {
    let response: any ;
    if(role == null || role == ''){
        response = axiosInstance.get(`api/v1/users?status=${status}&username=${value}`)
    }else{
        response = axiosInstance.get(`api/v1/users?status=${status}&username=${value}&role=${role}`)
    }
    return response
};
const getUserId = (id: number) => axiosInstance.get(`/api/v1/users/${id}`);
const searchUsers = (username : string) => axiosInstance.get(`api/v1/users/searches?username=${username}`);
const updateAcount = ( id: number, data: any) => axiosInstance.put(`api/v1/users/${id}`,data);
const status = (id: number, status: number) => axiosInstance.put(`api/v1/users/status?id=${id}&status=${status}`);
const removeAcount = (id: number) => axiosInstance.delete(`/api/v1/users/${id}`);
const seacrchAccount = (search: string) => axiosInstance.put(`/api/v1/users/searches?username${search}`);
const changePassWord = (data: any) => axiosInstance.put(`/api/v1/users/changePassword`, data)

const account: BasicUser = {
    getUserData,
    getUserId,
    searchUsers,
    updateAcount,
    removeAcount,
    status,
    seacrchAccount,
    changePassWord
}
export default account;